const config = {
  candidateBase: "https://candidate.hire3x.com/builder",
  websiteBase: "https://hire3x.com",
  trainingBase: "https://candidate.hire3x.com/training",
  trainingAdminBase: 'https://trainingadmin.hire3x.com',
  recruitment: 'https://recruitment.hire3x.com',
  assessment: 'https://judge.hire3x.com',
  collegeDashboard: 'https://college.hire3x.com',
}

export default config
